import React from 'react';

import  HindiCCA1and22024  from 'views/HindiCCA1and22024';
const BlogNewsroomPage = () => {
return <HindiCCA1and22024/>
};
export default BlogNewsroomPage;